import type { MessageKey } from '../i18n';

export type ProfileStatus = 'incomplete' | 'filled' | 'verified';

function hasFilledName(firstName?: string | null): boolean {
  return Boolean(firstName?.trim());
}

/**
 * Maps backend kycLevel (+ optional profile name) to one of three user-facing states.
 * Level 2+ always means verified; level 1 requires a filled name for "filled".
 */
export function resolveProfileStatus(
  kycLevel: number,
  firstName?: string | null
): ProfileStatus {
  const level = Math.min(3, Math.max(0, Math.trunc(kycLevel)));

  if (level >= 2) {
    return 'verified';
  }

  if (level >= 1 && hasFilledName(firstName)) {
    return 'filled';
  }

  return 'incomplete';
}

export function profileStatusMessageKey(status: ProfileStatus): MessageKey {
  switch (status) {
    case 'verified':
      return 'profile.statusVerified';
    case 'filled':
      return 'profile.statusFilled';
    default:
      return 'profile.statusIncomplete';
  }
}
